module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-content m-b-sm invitate-code-content"
  }, [_vm._v("\n        企业邀请码:\n        "), _c('span', {
    staticClass: "invitate-code",
    class: {
      'code_is_active': _vm.company.is_active === 1
    }
  }, [_vm._v(_vm._s(_vm.invitate_code))]), _vm._v(" "), (_vm.company.is_active === -1) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeCode(1)
      }
    }
  }, [_vm._v("开启邀请")]) : _vm._e(), _vm._v(" "), (_vm.company.is_active === 1) ? _c('button', {
    staticClass: "btn btn-defaul btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeCode(-1)
      }
    }
  }, [_vm._v("关闭邀请")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "main-content clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row p-b-sm table-filter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12 "
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\n                            状态：\n                            "), _c('label', {
    attrs: {
      "for": "status-online"
    }
  }, [_vm._v("在职")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    attrs: {
      "type": "checkbox",
      "name": "status",
      "value": "1",
      "id": "status-online"
    },
    domProps: {
      "checked": Array.isArray(_vm.status) ? _vm._i(_vm.status, "1") > -1 : (_vm.status)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.status = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.status = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status-offline"
    }
  }, [_vm._v("离职")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    attrs: {
      "type": "checkbox",
      "name": "status",
      "value": "-1",
      "id": "status-offline"
    },
    domProps: {
      "checked": Array.isArray(_vm.status) ? _vm._i(_vm.status, "-1") > -1 : (_vm.status)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "-1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.status = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.status = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12 text-right"
  }, [_vm._v("\n                                搜索：\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12 n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.search),
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-sm",
    attrs: {
      "type": "text",
      "placeholder": "输入姓名、手机号进行搜索",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-border"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.filterHrs), function(hr, ind) {
    return _c('tr', {
      key: hr._id
    }, [_c('td', [_vm._v(_vm._s(hr.hr ? hr.hr.realname : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hr.hr ? hr.hr.phone : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hr.invitation_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hr.report_number))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "btn btn-xs btn-default",
      class: {
        'btn-success': hr.status === 1
      }
    }, [_vm._v(_vm._s(hr.status == -1 ? '离职' : '在职'))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("format")(hr.join_time, 'YYYY-MM-DD', hr.join_time)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-xs btn-info",
      attrs: {
        "to": {
          'name': 'CompanyHRDashboard',
          'params': {
            'hr': hr.hr._id
          }
        }
      }
    }, [_vm._v("统计")]), _vm._v(" "), (hr.status === 1 && hr.hr.role === 2) ? _c('span', {
      staticClass: "btn btn-xs btn-primary",
      on: {
        "click": function($event) {
          _vm.setManager(hr)
        }
      }
    }, [_vm._v("设为管理")]) : _vm._e(), _vm._v(" "), (hr.status === 1 && hr.hr.role === 3) ? _c('span', {
      staticClass: "btn btn-xs btn-primary",
      on: {
        "click": function($event) {
          _vm.updateRange(hr)
        }
      }
    }, [_vm._v("管理范围")]) : _vm._e(), _vm._v(" "), (hr.status === 1 && hr.hr.role === 3) ? _c('span', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          _vm.cancelManager(hr)
        }
      }
    }, [_vm._v("取消管理")]) : _vm._e(), _vm._v(" "), (hr.status === 1) ? _c('span', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          _vm.leaveHr(hr)
        }
      }
    }, [_vm._v("离职")]) : _vm._e()], 1)])
  }))])])])])])]), _vm._v(" "), (_vm.modal.show) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n                    " + _vm._s(_vm.modal.title) + "\n                    "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeRangeSetPanel
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body w-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('tree-view', {
    attrs: {
      "model": _vm.orgs,
      "func": "4"
    },
    on: {
      "select": _vm.select
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 actions text-center p-t-b-sm"
  }, [_c('button', {
    staticClass: "btn-default btn btn-sm m-r-lg",
    attrs: {
      "type": "button",
      "disabled": !_vm.modal.actions.is_active
    },
    on: {
      "click": _vm.closeRangeSetPanel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary btn btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.modal.actions.is_active
    },
    on: {
      "click": _vm.saveRange
    }
  }, [_vm._v("确定")])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 col-xs-12 "
  }, [_c('h4', {
    staticClass: "table-name"
  }, [_vm._v("HR管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("姓名")]), _vm._v(" "), _c('th', [_vm._v("手机号")]), _vm._v(" "), _c('th', [_vm._v("测评量")]), _vm._v(" "), _c('th', [_vm._v("报告量")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("加入时间")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa5767e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/hr.vue
// module id = 471
// module chunks = 1